exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.picker-footer[data-v-42fb1c7a] {\r\n  text-align: right;\r\n  border-top: 1px solid #e8e8e8;\r\n  padding-top: 12px;\r\n  margin-top: 12px;\n}\r\n", ""]);

// exports
